import Axios from '@/http'
export default {
  /* 巡检轨迹V2 */
  pointTrail(id) {
    return new Promise((resolve, reject) => {
      Axios.post('scrollCheck/deviceSct/pointTrail', { id }).then((res) => {
        resolve(res)
      })
    })
  },

  /* 执行情况(人员巡检任务)V2 */
  deviceSctTaskExecute(id) {
    return new Promise((resolve, reject) => {
      Axios.post('scrollCheck/deviceSct/taskExecute', { id }).then((res) => {
        resolve(res)
      })
    })
  },

  /* 查看表单-设备提交的表单 */
  deviceReport(params) {
    return new Promise((resolve, reject) => {
      Axios.post('scrollCheck/sct/deviceReport', params).then((res) => {
        resolve(res)
      })
    })
  },

  /* 查看表单-设备提交的表单 */
  deviceReportV2(recordId) {
    return new Promise((resolve, reject) => {
      Axios.post('scrollCheck/deviceSct/deviceReport', { recordId }).then(
        (res) => {
          resolve(res)
        }
      )
    })
  }
}
